
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function GTMPageView() {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) { isFirstLoad.current = false; return; }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
      page_path: location.pathname
    });
  }, [location]);

  return null;
}
